export const UPDATE_LOGGED_IN = 'UPDATE_LOGGED_IN';
export const SET_LOGIN_PENDING = 'SET_LOGIN_PENDING';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_MERCHANT_DETAILS = 'SET_MERCHANT_DETAILS';
